import ReservationOverviewModel from "src/models/ReservationOverviewModel";
import dayjs from 'dayjs';
import { childAge, formatLocalDate } from "src/utils/common";
import { dateFormat } from "src/utils/dateFormat";

export const convertToOverview = (results) => {
    return { ...new ReservationOverviewModel(results) };
};

export const summerySectionAction = (summary) => {

    const calculateNights = (checkIn, checkOut) => {
        if (!checkIn || !checkOut) return null;

        const checkInDate = dayjs(checkIn, dateFormat);
        const checkOutDate = dayjs(checkOut, dateFormat);

        if (!checkInDate.isValid() || !checkOutDate.isValid()) return null;

        return checkOutDate.diff(checkInDate, 'day');
    };

    const nights = calculateNights(summary?.StartDate, summary?.EndDate);

    const summaryFields = [
        {
            label: 'Travel Start Date',
            value: formatLocalDate(summary?.StartDate),
            alwaysVisible: true
        },
        {
            label: 'Travel End Date',
            value: formatLocalDate(summary?.EndDate),
            alwaysVisible: true
        },
        {
            label: 'No of Nights',
            value: nights,
            alwaysVisible: true
        }
    ];

    return {
        summaryFields
    };

};

export const viewSummarySelectionAction = (type, primaryItem) => {
    const filedTypes = {
        itemStatus: {
            hotel: { label: "Item Status", path: "Status" },
            service: { label: "Item Status", path: "Status" }
        },
        itemReference: {
            hotel: { label: "Item Ref", path: "ItemReference" },
            service: { label: "Item Ref", path: "ItemReference" }
        },
        name: {
            hotel: { label: "Hotel", path: "PropertyName" },
            service: { label: "Service", path: "ServiceName" }
        },
        checkIn: {
            hotel: { label: "Check In", path: "CheckIn" },
            service: { label: "Check In", path: "CheckIn" }
        },
        checkOut: {
            hotel: { label: "Check Out", path: "CheckOut" },
            service: { label: "Check Out", path: "CheckOut" },
        },
        reference: {
            hotel: { label: "Voucher Ref", path: "VoucherRef" },
            service: { label: "Voucher Ref", path: "VoucherRef" }
        },
        buy: {
            hotel: { label: "Buy Total", path: "ContractBuy.Total" },
            service: { label: "Buy Total", path: "ContractBuy.Total" }
        },
        sell: {
            hotel: { label: "Sell Total", path: "ClientNetSell.Total" },
            service: { label: "Sell Total", path: "ClientNetSell.Total" }
        },
        voucher: {
            hotel: { label: "Client Voucher Raised", path: "IsClientVoucherRaised" },
            service: { label: "Client Voucher Raised", path: "IsClientVoucherRaised" }
        },
        confirmation: {
            hotel: { label: "Confirmation No", path: "ConfirmationNo" },
            service: { label: "Confirmation No", path: "ConfirmationNo" }
        }
    };

    const getNestedValue = (obj, path) => {
        return path.split('.').reduce((o, p) => (o || {})[p], obj);
    };

    return Object.entries(filedTypes).reduce((config, [key, typeFields]) => {
        const field = typeFields[type];
        return {
            ...config,
            [`${key}Label`]: field.label,
            [`${key}Value`]: getNestedValue(primaryItem, field.path)
        };
    }, {});
}

// Get dates based on guest type
export const getMinMaxDatesForGuest = (guest) => {
    const today = dayjs();
    const isAdult = guest.PaxType?.toLowerCase() === 'adult';

    if (isAdult) {
        // Adults must be 18 years or older
        const maxDate = today.subtract(childAge, 'year');
        const minDate = today.subtract(100, 'year');
        return { minDate, maxDate };
    } else {
        // Children must be under 18 years
        const maxDate = today.subtract(1, 'day');
        const minDate = today.subtract(childAge, 'year').add(1, 'day');
        return { minDate, maxDate };
    }
};